import { css } from '@emotion/core';

const styles = (theme, error) => {
  return {
    container: css`
      display: inline-flex;
    `,
    
    fieldSetClass: css`
    border: 0;
    ${theme?.classes?.structure?.padding?.none?.all}
    &:focus-within legend {
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
    }
  `,

    divider: css`
      ${theme && theme.classes
        ? theme.classes.structure.margin.space.bottom[2]
        : 'margin-right:1rem;'};
      & hr {
        border-bottom: 0;
        border-color: #d7d7de;
        border-width: 1px;
      }
    `,

    status: css`
      ${theme && theme.classes
        ? theme.classes.structure.margin.space.bottom[3]
        : 'margin-bottom:1.5rem;'};
        p:first-of-type {
          color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
        }
        span:first-of-type {
          color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
        }
    `,

    alert: css`
    ${theme && theme.classes
        ? theme.classes.structure.margin.space.bottom[2]
        : 'margin-bottom:1.5rem;'};
    `,

    body: css`
      align-items: center;
      box-sizing: border-box;
      justify-content: space-between;
      max-width: 31.25rem;

      > div {
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
      }
      & [tabindex]:focus {
        outline: 1px dashed;
        ${theme && theme.classes
        ? theme.classes.skin.outline.element.dark.styles
        : 'outline-color:rgba(42,46,105,1);'};
      }
      ${theme && theme.classes
        ? theme.classes.structure.padding.space.all[1]
        : 'margin:0.5rem;'};
      ${theme && theme.classes
        ? theme.classes.structure.padding.space.left[2]
        : 'margin:1rem;'};
      ${theme && theme.classes
        ? theme.classes.skin.bg.misc.white
        : 'background-color:rgba(255,255,255,1);label:white;'};
      border-radius: 0.25rem;
      border: 1px solid;
      ${error
        ? `border-color: ${theme?.cybs?.base?.wcag21?.romaRed ?? '#B3202A'};`
        : `border-color: ${theme?.cybs?.base?.wcag21?.stoneGrey ?? '#62798D'}`};

      & button[class*='vds-btn'] {
        margin-bottom: 0 !important;
      }
    `,

    fileSection: css`
      ${theme && theme.classes
        ? theme.classes.structure.margin.space.right[4]
        : 'margin-right:2rem;'};
      min-width: 6.5rem;
      max-width: 15rem;
      word-break: break-word;
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
      font-size: 16px;
    `,

    errorText: css`
      display: ${error ? 'inline;' : 'none;'};
      color: ${theme && theme.variables
        ? theme.variables.CSS_VARS['notificationError']
        : '#d50000;'};
      ${theme && theme.classes
        ? theme.classes.structure.margin.space.top[1]
        : 'margin-top:0.5rem;'};
      font-size: 12px;
      & svg.vds-icon {
        vertical-align: text-bottom;
        margin-right: 0.25rem;
      }
      & svg.vds-icon use,
      & svg.vds-icon circle,
      & svg.vds-icon ellipse,
      & svg.vds-icon line,
      & svg.vds-icon path,
      & svg.vds-icon polygon,
      & svg.vds-icon polyline,
      & svg.vds-icon rect {
        fill: ${theme?.cybs?.base?.wcag21?.romaRed ?? '#B3202A'};
      }
    `,

    inputUploadWrapper: css`
      display: inline-flex;
      input {
        width: 0.1px;
        height: 0.1px;
        clip: rect(0px, 0px, 0px, 0px);
        position: absolute;
      }
    `,

    noResults: css`
      ${theme && theme.classes
        ? theme.classes.structure.padding.space.top[2]
        : 'margin-top:2rem;'};
      ${theme && theme.classes
        ? theme.classes.structure.padding.space.bottom[2]
        : 'margin-bottom:2rem;'};
      ${theme && theme.classes
        ? theme.classes.structure.padding.space.left[2]
        : 'margin-left:2rem;'};
    `,

    subtitle: css`
      ${theme && theme.classes
        ? theme.classes.structure.margin.space.bottom[2]
        : 'margin-bottom:1rem;'};
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
    `,

    title: css`
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
      font-size: 16px;
      font-weight: bold;
      line-height: 1.25rem;
    `
  };
};

export default styles;
